import React, {useEffect, useState} from 'react';
import styles from "../Logging.module.scss";
import LoggingHeader from "../components/LoggingHeader/LoggingHeader";
import { Icon, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "semantic-ui-react";

import AppPagination from "../../../components/Pagination/AppPagination";
import LoggingFilter from "../components/LoggingFilter/LoggingFilter";
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import moment from "moment/moment";
import { changePageSize, deleteMessage, getMessages, setPageNum } from "./LoggingMessages.slice";
import { buildQueryString } from "../../../helpers/buildQueryString";
import LoggingConfirmModal from "../components/LoggingConfirmModal/LoggingConfirmModal";

const LoggingMessages = () => {
    const dispatch = useAppDispatch()
    const {pagination, messages} = useAppSelector(state => state.LoggingMessages)
    const [startDate, setStartDate] = useState<string | Date>(moment().toISOString());
    const [endDate, setEndDate] = useState<string | Date>(moment().add(24, "hours").toISOString());
    const [search, setSearch] = useState("");
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [deletingRecord, setDeletingRecord] = useState<string | number>("");

    useEffect(() => {
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize, from: startDate, to: endDate})
        dispatch(getMessages(query))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const onChangePageSize = (size: number) => {
        dispatch(changePageSize(size))
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: size, search, from: startDate, to: endDate})
        dispatch(getMessages(query))
    }

    const onChangePageNum = (pageNum: number) => {
        dispatch(setPageNum(pageNum))
        const query = buildQueryString({ pageNum, pageSize: pagination.pageSize, search, from: startDate, to: endDate})
        dispatch(getMessages(query))
    }

    const onSearch = (search: string) => {
        setSearch(search)
        const query = buildQueryString({ pageNum: 1, pageSize: pagination.pageSize, search,from:startDate,to:endDate})
        dispatch(getMessages(query))
        dispatch(setPageNum(1))
    }

    const onChangeStartDate = (date: string) => {
        const from = moment(date).utc().format()
        const to = moment(endDate).utc().format()
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize, search, from, to})
        setStartDate(date)
        if (!from.includes("Invalid") && !to.includes("Invalid")) {
            dispatch(getMessages(query))
        }
    }

    const onChangeEndDate = (date: string) => {
        const from = moment(startDate).utc().format()
        const to = moment(date).utc().format()
        const query = buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize, search, from, to})
        setEndDate(date)
        if (!from.includes("invalid") && !to.includes("invalid")) {
            dispatch(getMessages(query))
        }
    }

    const onDeleteMessage = () => {
        dispatch(deleteMessage(deletingRecord))
        setDeletingRecord("")
        setIsShowConfirmModal(false)
    }

    const showConfirmModal = (messageId: string | number) => {
        setDeletingRecord(messageId)
        setIsShowConfirmModal(true)
    }
    const closeConfirmModal = () => {
        setDeletingRecord("")
        setIsShowConfirmModal(false)
    }
    return (
        <div className={styles.page}>
            {isShowConfirmModal &&
                <LoggingConfirmModal
                    onDelete={onDeleteMessage}
                    text={`Are you sure you want to delete message with id ${deletingRecord}`}
                    onClose={closeConfirmModal}
                />}
            <LoggingHeader text={"Messages"}/>
            <div className={styles.container}>
                <LoggingFilter
                    showRefresh={true}
                    search={search}
                    setSearch={onSearch}
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={onChangeStartDate}
                    setEndDate={onChangeEndDate}
                />
            </div>
            <div className={styles.tableInner}>
                <Table celled inverted textAlign={'center'}>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Id</TableHeaderCell>
                            <TableHeaderCell>Time</TableHeaderCell>
                            <TableHeaderCell>Type</TableHeaderCell>
                            <TableHeaderCell>Message</TableHeaderCell>
                            <TableHeaderCell></TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {messages.map(message => {
                            return (
                                <TableRow>
                                    <TableCell>{message.id}</TableCell>
                                    <TableCell>
                                        {moment.utc(message.time).local().format("YYYY-MM-DD HH:mm:ss")}
                                    </TableCell>
                                    <TableCell>http</TableCell>
                                    <TableCell>{message.message}</TableCell>
                                    <TableCell>
                                        <button
                                            onClick={() => showConfirmModal(message.id)}
                                            className={styles.controlBtn}>
                                            <Icon color={"red"} name={"trash alternate"}/>
                                        </button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className={styles.pagination}>
                    <AppPagination isInvertColor={true} props={pagination} onChangePageSize={onChangePageSize} onChangePager={onChangePageNum} />
                </div>
            </div>
        </div>
    );
};

export default LoggingMessages;
